/*
 * @Author: SMG
 * @Date: 2016-4-20
 * @LastEditTime: 2021-04-08 15:08:28
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\logManageMent\logManageMent.js
 * @Description:  管理配置 日志管理
 */
'use strict';
angular.module('logManageMentModule', [
    'logManageMentLeftModule',
    'logManageMentRouterModule',
    'logManageMentSecurityLogModule',
    'logManageMentOperationLogModule',
    'logManageMentInterfaceLogModule',
    'logManageMentSystemLogModule',
    'logManageMentEventMonitoringModule',
    'logManageMentDistributeLogModule',
    'logManageMentHeiMaLogModule',
    'logManageMentOnlineUsersModule',
    'featureUsageStatisticsModule'
])
    .controller('logManageMentCtrl', ['$scope', '$state', function($scope, $state) {

    }]);
